export default __webpack_public_path__ + "static/media/almost-there-bg.eb3bba5e.svg";